import { render, staticRenderFns } from "./other-cancel-appointments.vue?vue&type=template&id=44db771a&"
import script from "./other-cancel-appointments.vue?vue&type=script&lang=js&"
export * from "./other-cancel-appointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports